import { http } from "./api";

/**
 * Verifica el estado de autenticación del usuario
 * @returns {Object} Datos de autenticación incluyendo accessTokenValid, refreshTokenValid, authenticated, refreshable
 */
export const userAuthentication = async () => {
    try {
        const response = await http.get("v1/auth/status");

        if (!response.success) {
            throw new Error(
                response.error || "Error al verificar autenticación"
            );
        }

        return response.data;
    } catch (error) {
        console.error("Error al autenticar el usuario:", error);
        throw error;
    }
};

/**
 * Renueva el access token usando el refresh token
 * @returns {Object} Nueva información de autenticación
 */
export const refreshAccessToken = async () => {
    try {
        const response = await http.post("v1/auth/refresh");

        if (!response.success) {
            throw new Error(response.error || "Error al renovar el token");
        }

        return response.data;
    } catch (error) {
        console.error("Error al renovar el token:", error);
        throw error;
    }
};

/**
 * Cierra la sesión del usuario
 * @returns {Object} Estado del logout
 */
export const userLogout = async () => {
    try {
        const response = await http.post("v1/auth/logout");

        if (!response.success) {
            throw new Error(response.error || "Error al cerrar sesión");
        }

        return {
            success: true,
            status: true,
            message: "Sesión cerrada correctamente",
        };
    } catch (error) {
        console.error("Error al cerrar sesión:", error);
        // Retornar error pero permitir logout en cliente de todas formas
        // para evitar sesiones colgadas
        return {
            success: false,
            status: false,
            message: error.message || "Error al cerrar sesión",
            error: error,
        };
    }
};

/**
 * Suplanta la identidad de un usuario y obtiene sus tokens
 * @param {string} targetUserId - ID del usuario a suplantar
 * @returns {Object} Datos del usuario suplantado incluyendo tokens
 */
export const impersonateUser = async (targetUserId) => {
    try {
        const response = await http.post("v1/auth/impersonate", {
            targetUserId,
        });

        if (!response.success) {
            throw new Error(
                response.error || "Error al suplantar identidad del usuario"
            );
        }

        return response.data;
    } catch (error) {
        console.error("Error al suplantar usuario:", error);
        throw error;
    }
};
